import ForgotPassword from "../../components/Auth/ForgotPassword";
import Footer from "../../components/Layout/Footer";
import Navbar from "../../components/Layout/Navbar";
import PageMeta from "../../components/pagesHelmet/PageMeta";

export default function ForgotPage() {
  return (
    <>
    <PageMeta title="Forgot Password | U2LR URL Shortener" noIndex />
    <Navbar />
        <div className="auth-page">
          <ForgotPassword />
        </div>
        <Footer />
    </>
  );
}